import { AlertCircle, RefreshCw } from 'lucide-react';

interface ErrorBannerProps {
  error: string | Error;
  onRetry?: () => void;
}

export function ErrorBanner({ error, onRetry }: ErrorBannerProps) {
  const message = error instanceof Error ? error.message : error;
  return (
    <div
      role="alert"
      className="flex items-start gap-3 px-4 py-3 rounded-lg border border-red-200 bg-red-50 text-red-700"
    >
      <AlertCircle size={16} className="flex-shrink-0 mt-0.5" />
      <div className="flex-1 min-w-0">
        <p className="text-xs font-semibold">Failed to load</p>
        <p className="text-xs text-red-600 mt-0.5 break-words">{message}</p>
      </div>
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          className="flex items-center gap-1.5 text-xs font-medium px-2.5 py-1 rounded border border-red-300 bg-white hover:bg-red-100 text-red-700"
        >
          <RefreshCw size={11} />
          Retry
        </button>
      )}
    </div>
  );
}
